import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { SignalButton } from '@vallift/ngl';

export interface ConfirmOverlayData {
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
}

@Component({
  selector: 'app-confirm-overlay',
  imports: [SignalButton],
  templateUrl: './confirm-overlay.html',
  styleUrl: './confirm-overlay.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmOverlayComponent {
  private readonly dialogRef = inject(DialogRef<boolean>);
  private readonly data = inject<ConfirmOverlayData>(DIALOG_DATA);

  readonly title = this.data.title;
  readonly message = this.data.message;
  readonly confirmLabel = this.data.confirmLabel ?? 'Delete';
  readonly cancelLabel = this.data.cancelLabel ?? 'Cancel';

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }
}
